import classNames from 'classnames';
import { MouseEventHandler, RefObject } from 'react';

import CleanButton from '../../../CleanButton/CleanButton';
import ColoredDot from '../../../ColoredDot/ColoredDot';
import { Option } from '../../RadioBar';

import styles from './RadioBarButton.module.css';

type RadioBarButtonProps<T> = {
    variant?: 'default' | 'boxed';
    size?: 'compact' | 'default' | 'large';
    option: Option<T>;
    currentValue?: T;
    onClick: (value: T, el: HTMLButtonElement) => void;
    buttonRef?: RefObject<HTMLButtonElement>;
};

const RadioBarButton = <T,>({
    variant,
    size,
    currentValue,
    option,
    onClick,
    buttonRef,
}: RadioBarButtonProps<T>) => {
    const isCurrent = currentValue === option.value;
    const optionClasses = classNames(styles.Root, {
        [styles.default]: variant === 'default',
        [styles.boxed]: variant === 'boxed',
        [styles.sizeCompact]: size === 'compact',
        [styles.sizeDefault]: size === 'default',
        [styles.sizeLarge]: size === 'large',
    });

    const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
        onClick(option.value, event.currentTarget);
    };

    return (
        <CleanButton
            className={classNames(optionClasses, isCurrent && styles.current)}
            onClick={handleClick}
            ref={buttonRef}
        >
            {option.label}

            {option.highlight && !isCurrent && (
                <ColoredDot
                    className={styles.Highlight}
                    variant="warning"
                    size="small"
                />
            )}
        </CleanButton>
    );
};

export default RadioBarButton;
